<template>
  <section class="section section--walkScore">
    <div class="container">
      <app-heading title="Walk Score" tag="h2" />
      <app-walk-score />
    </div>
  </section>
</template>

<script>
  import WalkScore from '@/pages/walkScore/walkScore.vue'
  import Heading from '@/components/heading/heading.vue'

  export default {
    components: {
      appWalkScore: WalkScore,
      appHeading: Heading
    }
  }
</script>
